<template>
    <role-form/>
</template>

<script>
    import RoleForm from './RoleForm'

    export default {
        components: {
            RoleForm
        }
    }
</script>
